<kendo-grid #grid [data]="gridView" [loading]="loading"
    [pageable]="total > state.take ? { buttonCount: 5, pageSizes: pageSizes} : false" [pageSize]="state.take"
    [skip]="state.skip" [sortable]="true" [sort]="state.sort" [filterable]="enableAdvanced" [filter]="state.filter"
    [groupable]="enableAdvanced" [group]="contactHistoryView.groups" [selectable]="{ mode: 'single' }"
    [columnMenu]="enableAdvanced" [resizable]="true" [reorderable]="enableAdvanced"
    (dataStateChange)="contactHistoryDataStateChange($event)" [kendoGridSelectBy]="">
    <kendo-grid-messages noRecords="{{ 'NO-CONTACT-HISTORY' | translate }}">
    </kendo-grid-messages>
    <kendo-grid-column *ngIf="showMethod" field="methodName" title="{{'METHOD' | translate}}" [width]="100">
    </kendo-grid-column>
    <kendo-grid-column *ngIf="showEntity" field="entityName" title="{{'CONTACT-HISTORY-ENTITY' | translate}}" [width]="120">
    </kendo-grid-column>
    <kendo-grid-column *ngIf="showConsent" field="consentName" title="{{'CONTACT-HISTORY-CONSENT' | translate}}" [width]="80">
    </kendo-grid-column>
    <kendo-grid-column *ngIf="showActivities" field="activitiesText" title="{{'CONTACT-HISTORY-ACTIVITIES' | translate}}" [width]="140">
    </kendo-grid-column>
    <kendo-grid-column field="areasText" title="{{'CONTACT-HISTORY-AREAS' | translate}}" [width]="150"
        *ngIf="visibleAreaColumn">
    </kendo-grid-column>
    <kendo-grid-column field="initiativeName" title="{{'CONTACT-HISTORY-INITIATIVE' | translate}}" [width]="150"
        *ngIf="visibleInitiativeColumn">
    </kendo-grid-column>
    <kendo-grid-column *ngIf="showIntensity" field="intensityName" title="{{'CONTACT-HISTORY-INTENSITY' | translate}}" [width]="80">
    </kendo-grid-column>
    <kendo-grid-column field="contactedOn" title="{{ 'CONTACTED-ON' | translate }}" filter="date" format="{0:d}"
        [width]="150">
        <ng-template kendoGridCellTemplate let-dataItem>
            <div *ngIf="dataItem.contactedOn!==null">
                {{ intl.formatDate(intl.parseDate(dataItem.contactedOn), "g") }}
            </div>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="createdByUserName" title="{{'CREATED-BY' | translate}}" [width]="140">
    </kendo-grid-column>
    <kendo-grid-column *ngIf="showMood" field="sentiment" title="{{'SENTIMENT' | translate}}" [width]="100">
        <ng-template kendoGridCellTemplate let-dataItem>
            <div class="text-center" *ngIf="dataItem.sentiment">
                <div [ngClass]="[getMoodClass(dataItem.sentiment)]" title="{{getMoodDisplayText(dataItem.sentiment)}}">
                </div>
            </div>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column [width]="100" title="{{ 'ACTIONS' | translate }}" class="text-center">
        <ng-template kendoGridCellTemplate let-dataItem>
            <ng-container>
                <i *ngIf="dataItem.systemGenerated" class="fas fa-eye fa-lg pr-4" title="{{'VIEW' | translate}}"
                    (click)="openEditContact(dataItem)">
                </i>
                <i *ngIf="!dataItem.systemGenerated && dataItem.createdBy === this.authenticationService.currentUser.userName"
                    class="fas fa-edit fa-lg" title="{{'EDIT' | translate}}" (click)="openEditContact(dataItem)">
                </i>
                &nbsp;
                <i *ngIf="!dataItem.systemGenerated && dataItem.createdBy === this.authenticationService.currentUser.userName"
                    class="fas fa-trash-alt fa-lg" title="{{'DELETE' | translate}}"
                    (click)="openDeleteContact(dataItem)">
                </i>
            </ng-container>
        </ng-template>
    </kendo-grid-column>
    <ng-template kendoGridDetailTemplate let-dataItem [kendoGridDetailTemplateShowIf]="showDetails">
        <div>{{dataItem.comments}}</div>
    </ng-template>
</kendo-grid>
<button id="expandBtn" kendoButton [primary]="true" type="button" class="mt-3 mb-2 mr-1 float-right"
    (click)="contact = null; contactHistoryDialogOpened = true">
    {{'RECORD-CONTACT' | translate}}<i class="far fa-plus"></i>
</button>

<!-- record contact history dialog dialog -->
<app-contact-history #contactHistory [contactHistoryDialogOpened]="contactHistoryDialogOpened" [memberId]="memberId"
    [contact]="contact" (added)="onContactHistoryAdded()" (cancelling)="contactHistoryDialogOpened=false">
</app-contact-history>

<!-- delete contact history confirmation dialog -->
<kendo-dialog *ngIf="contactHistoryDeleteDialogOpened" title="{{'PLEASE-CONFIRM' | translate}}" [width]="400"
    (close)="contactHistoryDeleteDialogOpened = false">
    <p>{{'CONFIRM-CONTACT-HISTORY-DELETION' | translate}}</p>
    <div class="k-font-weight-bold" style="max-width:500px;max-height:300px;">{{contactedOn}}<br />{{contact.comments}}
    </div>
    <kendo-dialog-actions>
        <button kendoButton (click)="contactHistoryDeleteDialogOpened = false">{{'NO' | translate}}</button>
        <button appPreventClick kendoButton (click)="deleteContactHistory()">{{'YES' | translate}}</button>
    </kendo-dialog-actions>
</kendo-dialog>